import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import "./App.css";
import Calculator from "./components/Calculator";
import {
  MuiThemeProvider,
  createMuiTheme,
  Typography,
  Grid,
  AppBar
} from "@material-ui/core";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#ff6600",
      dark: "#ff6600"
    }
  },
  typography: { useNextVariants: true }
});

const App = ({ match }) => {
  let region = "au"; // match.params.id;
  let productSpec = "";
  if (region === "au") {
    productSpec = "DN50";
  } else if (region === "us" || region === "ca") {
    productSpec = '1½" (DN40)';
  }
  return (
    <div>
      <MuiThemeProvider theme={theme}>
        <AppBar position="static" style={{ padding: "8px 24px" }}>
          <div className="AppBar">
            <Grid container spacing={24}>
              <Grid item xs={6}>
                <Typography style={{ color: "white" }} variant="h5">
                  Swivelpole™
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  style={{ color: "white" }}
                  variant="h5"
                  align="right">
                  Cost Comparison Calculator{" "}
                  <span style={{ textTransform: "uppercase" }}>({region})</span>
                </Typography>
              </Grid>
            </Grid>
          </div>
        </AppBar>
        <div className="App">
          <div className="intro" style={{ marginTop: "48px" }}>
            <Typography
              variant="body1"
              style={{ marginTop: "32px", marginBottom: "64px" }}>
              This Swivelpole™ Cost Comparison Calculator is designed to
              demonstrate the cost savings in converting non-lowering walkway
              mounted poles to lowering poles using the Safe Swivel™ Joint
              (SSJ). Savings are shown from installation through to total
              estimated savings over the lifecycle of a plant. Cost is based on
              the standard Safe Swivel™ Joint to suit {productSpec} pipe.
            </Typography>
          </div>
          <Calculator region={region} />
        </div>
      </MuiThemeProvider>
    </div>
  );
};

const AppRouter = () => (
  <Router>
    {/* <Route exact path="/:id" component={App} /> */}
    <Route exact path="/" component={App} />
  </Router>
);

export default AppRouter;
